export default [
    {
        name: 'Projetos',
        url: '/sgtec/apoios/projetos',
        icon: 'fa fa-book',
        badge: {
            variant: 'primary',
            text: 'APOIO'
        },
        regras: 'SGTEC-APOIO-PRJ-00'
    },
    {
        name: 'Pagamentos',
        url: '/sgtec/apoios/pagamentos',
        icon: 'fa fa-dollar',
        badge: {
            variant: 'primary',
            text: 'APOIO'
        },
        regras: 'SGTEC-APOIO-PAG-00'
    }
]
